module.exports = __webpack_public_path__ + "images/dir-empty@2x-24b641c791aa68336caab924a7c10399.png";